import { useRoutes } from 'react-router-dom';
import PublicRoutes from './PublicRoutes';
import ProtectedRoute from './ProtectedRoutes';


export default function Routes() {
    return useRoutes([PublicRoutes, ProtectedRoute]);
}